<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Summary Tester</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Delivery Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @change="handelChangeDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedBottle" @change="handleChangeBottle" />
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-checkbox v-model="isAdelphi" label="Ambil dari stok adelphi" @change="handleCheckAdelphi" />
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading"
                                v-bind="attrs"
                                type="table-tbody">
                            </v-skeleton-loader>
                            <v-simple-table v-else fixed-header height="400" ref="tabelExport">
                                <template v-slot:default class="spreadsheet-table">
                                    <thead>
                                        <tr>
                                            <th rowspan="2" class="header-cell" style="width:10px;"></th>
                                            <th class="header-cell text-center" colspan="2">{{ selectedBottle }}ML</th>
                                            <th rowspan="2" class="header-cell text-center">TOTAL</th>
                                            <th class="header-cell text-center" v-for="(coordinator, idc) in coordinators" :key="`head_coor_${idc}`">
                                                {{ coordinator.coordinator_name }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="header-cell text-center" colspan="2">EXPIRED</th>
                                            <th class="header-cell text-center" v-for="(coordinator, idc) in coordinators" :key="`head2_coor_${idc}`">{{ expiredDate }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(product, idp) in filteredProducts" :key="idp">
                                            <td>{{ idp + 1 }}</td>
                                            <td>{{ product.code }}</td>
                                            <td>{{ product.name }} ({{ product.size }}ML)</td>
                                            <td class="text-center">{{ getQtyTotal(product.code) }}</td>
                                            <td class="text-center" v-for="(coordinator, idc) in coordinators" :key="`td_coor_${idc}`">
                                                {{ getQtyCoord(coordinator.coordinator_code, product.code) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th class="text-right" colspan="3">JUMLAH TOTAL</th>
                                            <th class="text-center">{{ getSumQtyTotal() }}</th>
                                            <th class="text-center" v-for="(coordinator, idc) in coordinators" :key="`tfoot_coor_${idc}`">
                                                {{ getSumQtyCoord(coordinator.coordinator_code) }}
                                            </th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            date: '',
            expiredDate: '',
            dateMenu: false,
            isLoading: false,
            isAdelphi: false,
            items: [],
            bottles: [],
            products: [],
            coordinators: [],
            selectedBottle: '250',
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2,
            },
        }
    },

    computed: {
        filteredProducts() {
            return this.products.filter( product => product.size === this.selectedBottle)
                .sort((a,b) => {
                    if (a.sort_no < b.sort_no) return -1;
                    if (a.sort_no > b.sort_no) return 1;
                    return 0;
                });
        }
    },

    async created() {
        this.date = moment().format('YYYY-MM-DD');
        this.isLoading = true;
        this.getBottles();
        this.getProducts();
        this.fetchData();
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        async getProducts() {
            let response = await this.$store.dispatch('variant/getObjs');
            if (response.data.status == 'success') {
                this.products = response.data.data;
                this.products = this.products.filter(p => p.is_active == 1)
                    .sort((a, b) => a.sort_no - b.sort_no);
            }
        },
        handelChangeDate() {
            this.fetchData();
        },
        handleChangeBottle() {
            this.fetchData();
        },
        handleCheckAdelphi() {
            this.fetchData();
        },
        getQtyTotal(productCode) {
            let result = 0;

            this.coordinators.forEach((coord) => {
                result += this.getQtyCoord(coord.coordinator_code, productCode);
            })

            return result;
        },
        getSumQtyTotal() {
            let result = 0;
            if (this.filteredProducts) {
                result = this.filteredProducts.reduce((total, item) => total + this.getQtyTotal(item.code), 0);
            }
            return result;
        },
        getQtyCoord(coordinatorCode, productCode) {
            let result = 0;

            const item = this.items.find((i) => i.product_code === productCode && i.coordinator_code === coordinatorCode);
            if (item) {
                if (this.isAdelphi) {
                    result = parseInt(item.quantity_from_adelphi);
                } else {
                    result = parseInt(item.quantity);
                }
            }

            return result;
        },
        getSumQtyCoord(coordinatorCode) {
            let result = 0;
            if (this.filteredProducts) {
                result = this.filteredProducts.reduce((total, item) => total + this.getQtyCoord(coordinatorCode, item.code), 0);
            }
            return result;
        },
        async fetchData() {
            this.isLoading = true;

            try {
                const response = (await this.$store.dispatch('tester/getSummary', {
                    date: this.date,
                }));

                const data = response.data.data;

                // this.date = data.date;
                this.expiredDate = data.expired_date;
                this.coordinators = data.coordinators;
                this.items = data.items;

            } catch (error) {
                console.log('Error fetching summary tester:', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            let fileName = this.isAdelphi ? 'Ambil-Dari-Adelphi.xlsx' : 'Summary-Tester.xlsx';

            writeFileXLSX(wb, fileName);
        }
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>